import {
  AfterViewInit,
  Component,
  DestroyRef,
  effect,
  ElementRef,
  inject,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { NgClass } from '@angular/common';
import { LayoutService } from '../layout-service';
import { Header } from '../header/header';
import { Footer } from '../footer/footer';
import { SideMenu } from '../side-menu/side-menu';
import { Session } from '../../../core/services/session/session';
import { StorageService } from '../../../core/services/storage/storage';
import { SharedApis } from '../../../core/services/shared-apis/shared-apis';
import { DelegatedUIErrorI } from '../../shared/interfaces/delegated-ui-error.interface';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastService } from '../../../core/services/toast/toast.service';

@Component({
  selector: 'app-base',
  imports: [Header, RouterOutlet, Footer, SideMenu, NgClass],
  templateUrl: './base.html',
  styleUrl: './base.scss',
})
export class Base implements AfterViewInit, OnInit {
  @ViewChild('base')
  public base?: ElementRef<HTMLDivElement>;
  private readonly layoutService = inject(LayoutService);
  private readonly sessionService = inject(Session);
  private readonly storageService = inject(StorageService);
  private readonly sharedApisService = inject(SharedApis);
  private readonly toastService = inject(ToastService);

  private destroyRef = inject(DestroyRef);

  resizeObserver?: ResizeObserver;
  isCollapsed = signal<boolean>(false);
  screenWidth: number;

  constructor() {
    this.screenWidth = window.innerWidth;
    effect(() => {
      this.toggleSideMenu();
    });
  }

  ngOnInit(): void {
    this.findLoggedInUser();
  }

  ngAfterViewInit(): void {
    if (this.base?.nativeElement) {
      this.resizeObserver = new ResizeObserver((entries) => {
        const width = entries[0].contentRect.width;
        this.screenWidth = width;

        if (width <= 720) {
          this.isCollapsed.set(true);
          this.layoutService.isSideMenuCollapsed.set(true);
        } 
      });

      this.resizeObserver.observe(this.base.nativeElement);
    }
  }

  findLoggedInUser() {
    const loggedInUser = this.storageService.loggedInUser;

    this.sharedApisService
      .findLoggedInUser()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (findLoggedInUserResponse) => {
          const { data } = findLoggedInUserResponse;
          this.sessionService.addLoggedInUser(data);

          if (JSON.stringify(loggedInUser) === JSON.stringify(data)) {
            return;
          }

          this.storageService.loggedInUser = data;
        },
        error: (err: DelegatedUIErrorI) => {
          this.toastService.showError(err.description, err.title);
        },
      });
  }

  toggleSideMenu() {
    this.isCollapsed.update(() => this.layoutService.isSideMenuCollapsed());
  }
}
